/* Runtime configuration, fetched from /config.json (NOT baked into the
   bundle). Dev: scripts/render-config.mjs renders it from env vars.
   Prod: cmd.sh renders it from env vars via envsubst at container start.
   Same image serves any environment. */

export interface RuntimeConfig {
  apiUrl: string
  /* "hostname=tenantId" comma list, e.g.
     "partner.maluwilz.de=maluwilz,mwpartner.l.t=maluwilz".
     A flat string because envsubst cannot safely emit JSON objects. */
  tenantHosts: string
  defaultTenant: string
}

let cached: RuntimeConfig | null = null

/* A relative apiUrl ("/api") resolves against the current origin - the same
   image then serves any number of tenant domains with same-origin API calls
   (partner.maluwilz.de/api, partner.plcc-gmbh.de/api). */
export function resolveApiUrl(apiUrl: string, origin: string): string {
  return apiUrl.startsWith('/') ? `${origin}${apiUrl}` : apiUrl
}

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached
  const res = await fetch('/config.json', { cache: 'no-cache' })
  if (!res.ok) throw new Error(`Failed to load /config.json: ${res.status}`)
  const config = (await res.json()) as RuntimeConfig
  if (!config.apiUrl) throw new Error('config.apiUrl missing')
  if (!config.defaultTenant) throw new Error('config.defaultTenant missing')
  config.apiUrl = resolveApiUrl(config.apiUrl, window.location.origin)
  cached = config
  return config
}

export function parseTenantHosts(tenantHosts: string): Record<string, string> {
  const map: Record<string, string> = {}
  for (const pair of tenantHosts.split(',')) {
    const [host, tenant] = pair.split('=').map((s) => s.trim())
    if (host && tenant) map[host.toLowerCase()] = tenant
  }
  return map
}

/* Test seam */
export function resetConfigCache(): void {
  cached = null
}
